import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient } from "@angular/common/http";
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class UserService extends BaseService {
    constructor(
        private fb: FormBuilder,
        private http: HttpClient
    ) {
        super();
    }

    formModel = this.fb.group({
        UserName: ['', Validators.required],
        Email: ['', Validators.email],
        FullName: [''],
        Passwords: this.fb.group({
            Password: ['', [Validators.required]],
            ConfirmPassword: ['', Validators.required]
        }, { validator: this.comparePasswords })
    });

    formModelReset = this.fb.group({
        Passwords: this.fb.group({
            Password: ['', [Validators.required]],
            ConfirmPassword: ['', Validators.required]
        }, { validator: this.comparePasswords })
    });

    comparePasswords(fb: FormGroup) {
        let confirmPswrdCtrl = fb.get('ConfirmPassword');
        //passwordMismatch
        //confirmPswrdCtrl.errors={passwordMismatch:true}
        if (confirmPswrdCtrl.errors == null || 'passwordMismatch' in confirmPswrdCtrl.errors) {
            if (fb.get('Password').value != confirmPswrdCtrl.value)
                confirmPswrdCtrl.setErrors({ passwordMismatch: true });
            else
                confirmPswrdCtrl.setErrors(null);
        }
    }

    register() {
        var body = {
            UserName: this.formModel.value.UserName,
            Email: this.formModel.value.Email,
            FullName: this.formModel.value.FullName,
            Password: this.formModel.value.Passwords.Password
        };
        return this.http.post(this.BaseURI + '/ApplicationUser/Register', body);
    }

    login(formData) {
        return this.http.get(this.BaseURI + '/ApplicationUser/Login?userName=' + formData.UserName + '&password=' + formData.Password);
    }

    forgotPass(formData) {
        var body = {
            Email: formData.Email,
        };
        return this.http.post(this.BaseURI + '/ApplicationUser/ForgotPass', body);
    }

    resetPass(token, userName) {
        var body = {
            UserName: userName,
            Password: this.formModelReset.value.Passwords.Password,
            Token: token
        };
        return this.http.post(this.BaseURI + '/ApplicationUser/ResetPass', body);
    }

    logOut() {
        return this.http.get(this.BaseURI + '/ApplicationUser/Logout');
    }

    getUserProfile() {
        return this.http.get(this.BaseURI + '/ApplicationUser');
    }

    getUserPermission(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(this.BaseURI + '/ApplicationUser/Permission').subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }

    getUserMenu() {
        return this.http.get(this.BaseURI + '/ApplicationUser/Menu');
    }

    getListUser() {
        return this.http.get(this.BaseURI + '/ApplicationUser/List');
    }

    getUserById(userId) {
        return this.http.get(this.BaseURI + '/ApplicationUser/User/' + userId);
    }

    deleteUserById(userId) {
        return this.http.delete(this.BaseURI + '/ApplicationUser/' + userId);
    }

    saveUser(user: any) {
        if (user.id && user.id.length > 0)
            return this.http.put(this.BaseURI + '/ApplicationUser', user);
        else
            return this.http.post(this.BaseURI + '/ApplicationUser', user);
    }

    authorizedUser(user: any) {
        return this.http.put(this.BaseURI + '/ApplicationUser/AuthorizedUser', user);
    }
}